/* @flow */

import * as React from 'react';
import { compose } from 'ramda';
import { withRouter } from 'react-router-dom';
import BaseButton from '@e180/ui/lib/component/button/BaseButton';
import { hasURLProtocol } from '@e180/util/lib/url';

// eslint-disable-next-line no-duplicate-imports
import type { Props } from '@e180/ui/lib/component/button/BaseButton';

const BaseButtonWithClick = ({
  href,
  handleClick,
  history,
  stopPropagation,
  ...props
}: Props): React.Node => {
  const onClick = (e: MouseEvent) => {
    if (handleClick || href) {
      e.preventDefault();

      if (stopPropagation) {
        e.stopPropagation();
      }
    }

    const { currentTarget } = e;

    if (currentTarget instanceof HTMLInputElement) {
      currentTarget.blur();
    }

    if (handleClick) {
      handleClick(e);
    }

    if (href) {
      if (hasURLProtocol(href)) {
        window.open(href, '_blank');
      } else {
        history.push(href);
      }
    }
  };

  return <BaseButton onClick={onClick} {...props} />;
};

export default compose(React.memo, withRouter)(BaseButtonWithClick);
